module.exports = __webpack_public_path__ + "img/gift-01-c3.97af9291.png";